<template>
  <div>
    <template v-if="category && category.length > 0">
      <div class="caption">
        {{ category[0].name }}
      </div>
      <template v-for="(opt, oindex) in category[0].option">
        <product-option-item
          :level="0"
          v-model="value"
          :option="opt"
          :key="'option_' + opt + '_' + oindex"
          @onClick="
            option1 = opt;
            onChangeOption();
          "
          :stock="stock"
          :isSelected="option1 && option1 == opt"
          @focusOption="focusOption"
          @blurOption="$emit('blurOption')"
        >
          {{ opt }}
        </product-option-item>
      </template>
      <template v-if="category.length > 1">
        <div class="caption">
          {{ category[1].name }}
        </div>

        <template v-for="(opt, oindex) in category[1].option">
          <product-option-item
            :level="1"
            v-model="value"
            :option="opt"
            :key="'option_' + opt + '_' + oindex"
            @onClick="
              option2 = opt;
              onChangeOption();
            "
            :stock="stock"
            :isSelected="option2 && option2 == opt"
            @focusOption="focusOption"
            @blurOption="$emit('blurOption')"
          >
            <!-- <v-avatar v-if="stype[7]">
                    <img :src="stype[7]" :alt="stype[1]" />
                </v-avatar>  -->
            {{ opt }}
          </product-option-item>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const ProductOptionItem = () => import("./ProductOptionItem");
export default {
  props: ["value", "category", "stock"],
  computed: {
    ...mapGetters({
      theme: "getTheme",
    }),
  },
  components: {
    ProductOptionItem,
  },
  data() {
    return {
      option1: null,
      option2: null,
    };
  },
  mounted() {
    try {
      var options = this.value.split("/");
      this.option1 = options && options.length > 0 ? options[0] : null;
      this.option2 = options && options.length > 1 ? options[1] : null;
    } catch (error) {
      //
    }
  },
  methods: {
    focusOption(payload) {
      this.$emit("focusOption", payload);
    },
    onChangeOption() {
      if (this.category.length > 1) {
        if (this.option1 && this.option2) {
          this.$emit("input", `${this.option1}/${this.option2}`);
          this.$emit("changeOption", `${this.option1}/${this.option2}`);
        } else {
          this.$emit("input", null);
          this.$emit("changeOption", null);
        }
      } else {
        this.$emit("input", this.option1 ? this.option1 : null);
        this.$emit("changeOption", this.option1 ? this.option1 : null);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
